import mergeWith from "lodash/mergeWith";

import { defaultBlockSettings } from "@components/cmsBlocks/configs";
import getBlockTemplate from "@components/cmsBlocks/getBlockTemplate";
import { getPageFolderName, getPageTypes } from "@config/cms";

export const mergeBlockSettingsWithDefault = (block = {}) => {
  return {
    common: {
      ...defaultBlockSettings.common,
      ...block.settings.common,
    },
    specific: {
      ...defaultBlockSettings.specific[block.name],
      ...block.settings.specific,
    },
  };
};

export const mergeDataBlockWithDefaultData = (
  data = {},
  name,
  otherData = true,
) => {
  try {
    const blockTemplate = getBlockTemplate(name);

    const block = {
      ...(otherData ? data : {}),
      settings: {
        ...mergeWith({}, blockTemplate.block.settings, data.settings),
      },
      data: {
        ...mergeWith({}, blockTemplate.block.data, data.data),
      },
    };

    return block;
  } catch (e) {
    console.log("[mergeDataBlockWithDefaultData] catch:", e);
  }
};

export const getPageLink = (type, slug) => {
  const isRegular = getPageTypes().regular === type;
  type = getPageFolderName()[type];
  const isHome = slug === "/";

  const link = isHome ? slug : isRegular ? `/${slug}` : `/${type}/${slug}`;
  return link;
};

export const deepClone = (obj) => {
  if (typeof structuredClone !== "undefined") {
    return structuredClone(obj);
  }

  return JSON.parse(JSON.stringify(obj));
};

export const cloneBlocks = (blocks) => {
  if (!Array.isArray(blocks)) {
    return blocks;
  }

  return blocks.map((block) => deepClone(block));
};

// import { specificBlockOptions } from "@components/cmsBlocks/configs";
// import { createBlockByName } from "@components/cmsBlocks/getBlockTemplate";

// export const defaultPageBlocks = {
//   regular: [createBlockByName("hero")],
//   news: [createBlockByName("hero"), createBlockByName("news")],
//   promo: [createBlockByName("hero"), createBlockByName("promo")],
//   story: [
//     createBlockByName("hero"),
//     createBlockByName("content", {
//       specific: {
//         columns: {
//           value: specificBlockOptions.content.columns.options[0].value,
//         },
//         picture: {
//           value: specificBlockOptions.content.picture.options[2].value,
//         },
//         titlePosition: {
//           value: specificBlockOptions.content.titlePosition.options[0].value,
//         },
//       },
//     }),
//   ],
//   route: [
//     createBlockByName("hero"),
//     createBlockByName("stops"),
//     createBlockByName("traveling"),
//     createBlockByName("content"),
//     createBlockByName("popular"),
//   ],
//   destination: [
//     createBlockByName("hero"),
//     createBlockByName("traveling"),
//     createBlockByName("content", {
//       specific: {
//         columns: {
//           value: specificBlockOptions.content.columns.options[1].value,
//         },
//         picture: {
//           value: specificBlockOptions.content.picture.options[0].value,
//         },
//         titlePosition: {
//           value: specificBlockOptions.content.titlePosition.options[1].value,
//         },
//       },
//     }),
//     createBlockByName("popular", {
//       specific: {
//         contentType: {
//           value: specificBlockOptions.popular.contentType.options[1].value,
//         },
//       },
//     }),
//   ],
// };
